const GetContractDetailReducer = (state = { type: 'LOADING_CONTRACT_DETAIL_VIEW_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_CONTRACT_DETAIL_VIEW_ACTION':
            return action
        default:
            return state
    }
}

const GetArchletDetailReducer = (state = { type: 'LOADING_ARCHLET_DETAIL_VIEW_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_ARCHLET_DETAIL_VIEW_ACTION':
            return action
        default:
            return state
    }
}

const GetArchletDropdownReducer = (state = { type: 'LOADING_ARCHLET_DROPDOWN_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_ARCHLET_DROPDOWN_ACTION':
            return action
        case 'RESET_ARCHLET_DROPDOWN_ACTION':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}


const GetAribaDropdownReducer = (state = { type: 'LOADING_ARIBA_DROPDOWN_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_ARIBA_DROPDOWN_ACTION':
            return action
        case 'RESET_ARIBA_DROPDOWN_ACTION':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}

const GetAribaKpiReducer = (state = { type: 'LOADING_ARIBA_DETAIL_VIEW_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_ARIBA_DETAIL_VIEW_ACTION':
            return action
        default:
            return state
    }
}

export {
    GetContractDetailReducer,
    GetArchletDetailReducer,
    GetArchletDropdownReducer,
    GetAribaDropdownReducer,
    GetAribaKpiReducer
}